import React from 'react';
import { ScrollTextIcon, SearchIcon, FilterIcon, DownloadIcon, ClockIcon, ShieldAlertIcon } from 'lucide-react';
export function AuditLogModule({
  role
}: {
  role: string;
}) {
  const logs = [{
    id: 'AUD-001',
    timestamp: '2026-03-30 14:32:10',
    admin: 'Obinna U.',
    action: 'Rate Table Approved',
    module: 'Rate Table Manager',
    description: 'Approved Future Scholar Fund v2.4 rate table.',
    severity: 'High'
  }, {
    id: 'AUD-002',
    timestamp: '2026-03-30 14:15:00',
    admin: 'Adewale O.',
    action: 'Rate Table Uploaded',
    module: 'Rate Table Manager',
    description: 'Uploaded Future Scholar Fund v2.4 rate table CSV.',
    severity: 'Medium'
  }, {
    id: 'AUD-003',
    timestamp: '2026-03-30 11:45:22',
    admin: 'System',
    action: 'Automated Notification',
    module: 'Notification Manager',
    description: 'Sent 142 AutoGuard renewal reminders.',
    severity: 'Low'
  }, {
    id: 'AUD-004',
    timestamp: '2026-03-29 16:20:05',
    admin: 'Sarah J.',
    action: 'Claim Status Updated',
    module: 'Claims Management',
    description: 'Updated CLM-8492 status from Submitted to Under Review.',
    severity: 'Medium'
  }, {
    id: 'AUD-005',
    timestamp: '2026-03-29 09:10:00',
    admin: 'Obinna U.',
    action: 'User Suspended',
    module: 'User Management',
    description: 'Suspended USR-1031 due to suspected fraud.',
    severity: 'Critical'
  }];
  const getSeverityBadge = (severity: string) => {
    switch (severity) {
      case 'Critical':
        return 'bg-rose-100 text-rose-700';
      case 'High':
        return 'bg-amber-100 text-amber-700';
      case 'Medium':
        return 'bg-blue-100 text-blue-700';
      case 'Low':
        return 'bg-gray-100 text-gray-600';
      default:
        return 'bg-gray-100 text-gray-600';
    }
  };
  return <div className="space-y-6" data-id="element-110">
      <div className="flex justify-between items-center" data-id="element-111">
        <div data-id="element-112">
          <h2 className="text-2xl font-bold text-[#0D3B3B]" data-id="element-113">Audit Log</h2>
          <p className="text-sm text-gray-500" data-id="element-114">
            Tamper-evident log of all admin actions and system events.
          </p>
        </div>
        <button className="bg-white border border-gray-200 text-[#0D3B3B] px-4 py-2 rounded-xl font-bold text-sm flex items-center gap-2 hover:bg-gray-50 transition-colors" data-id="element-115">
          <DownloadIcon className="w-4 h-4" data-id="element-116" /> Export Log
        </button>
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden" data-id="element-117">
        <div className="p-4 border-b border-gray-100 flex gap-4" data-id="element-118">
          <div className="relative flex-1" data-id="element-119">
            <SearchIcon className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" data-id="element-120" />
            <input type="text" placeholder="Search logs by admin, action, or description..." className="w-full pl-10 pr-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#2BA89D]/20 focus:border-[#2BA89D]" data-id="element-121" />
          </div>
          <button className="px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm font-bold text-gray-600 flex items-center gap-2 hover:bg-gray-100" data-id="element-122">
            <FilterIcon className="w-4 h-4" data-id="element-123" /> Filter
          </button>
        </div>

        <div className="overflow-x-auto" data-id="element-124">
          <table className="w-full text-left" data-id="element-125">
            <thead data-id="element-126">
              <tr className="bg-gray-50/50 text-xs uppercase tracking-wider text-gray-500 font-semibold" data-id="element-127">
                <th className="px-6 py-4" data-id="element-128">Timestamp</th>
                <th className="px-6 py-4" data-id="element-129">Admin / System</th>
                <th className="px-6 py-4" data-id="element-130">Action & Module</th>
                <th className="px-6 py-4" data-id="element-131">Description</th>
                <th className="px-6 py-4" data-id="element-132">Severity</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-133">
              {logs.map(log => <tr key={log.id} className="hover:bg-gray-50" data-id="element-134">
                  <td className="px-6 py-4" data-id="element-135">
                    <div className="flex items-center gap-2 text-sm font-bold text-[#0D3B3B]" data-id="element-136">
                      <ClockIcon className="w-4 h-4 text-gray-400" data-id="element-137" />
                      {log.timestamp.split(' ')[1]}
                    </div>
                    <div className="text-xs text-gray-500 ml-6" data-id="element-138">
                      {log.timestamp.split(' ')[0]}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-sm font-bold text-[#0D3B3B]" data-id="element-139">
                    {log.admin}
                  </td>
                  <td className="px-6 py-4" data-id="element-140">
                    <div className="text-sm font-bold text-[#0D3B3B]" data-id="element-141">
                      {log.action}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-142">{log.module}</div>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700 max-w-xs truncate" data-id="element-143">
                    {log.description}
                  </td>
                  <td className="px-6 py-4" data-id="element-144">
                    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold ${getSeverityBadge(log.severity)}`} data-id="element-145">
                      {log.severity === 'Critical' && <ShieldAlertIcon className="w-3.5 h-3.5" data-id="element-146" />}
                      {log.severity}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}